import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "locationMap"
const LocationMapIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        d="M20 17.537C20 20.003 16.42 22 12 22s-8-1.997-8-4.463c0-1.44 1.22-2.722 3.11-3.537l.64 1.015C6.67 15.517 6 16.21 6 16.98c0 1.54 2.69 2.79 6 2.79s6-1.25 6-2.79c0-.77-.67-1.462-1.75-1.964L16.89 14c1.89.815 3.11 2.098 3.11 3.537zM18 8c0 4.364-5.078 9.491-5.293 9.707a.999.999 0 0 1-1.415 0C11.077 17.491 6 12.364 6 8c0-3.308 2.691-6 6-6s6 2.692 6 6zm-6 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
      />
    </svg>
  )
}
export default LocationMapIcon
